import * as React from 'react';
import { SessionNote, SubjectNote, TestNote } from 'webportalclient';
import { NotesModal } from "../../misc/components/NotesModal";
import { SpirometryAnalysisSetTypeEnum } from '../../misc/api/ApiSpirometryAnalysisSetType';
import { ModalSize } from '../../misc/components/modal';

export interface SummaryPanelProps {
    notesButtonName: string;
    notesButtonDisabled: boolean;
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    isLoading: boolean;
    isAddingNotesEnabled: boolean;
    showNotesCount?: boolean;
    notesErrorStatus: string | undefined;
    modalSize: ModalSize;
    onEditNote: (id: string, comment: string, annotation: string) => void;
    onAddNote: (annotation: string) => void;
}

export const SummaryPanel = (props: SummaryPanelProps) => {
    const [isModalVisibility, setIsModalVisibility] = React.useState(false);
    const [isAddingNewNote, setIsAddingNewNote] = React.useState(false);
    
    return (
        <>
            <div className="panel panel-default">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-12">
                            <button disabled={props.notesButtonDisabled} className="btn btn-primary" onClick={() => setIsModalVisibility(true)} data-automationid="NotesButton">
                                {props.notesButtonName}
                                {props.showNotesCount ? <>&nbsp;<span className="badge badge-info">{props.notes.length}</span></> : null}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <NotesModal
                isVisible={isModalVisibility}
                header={props.notesButtonName}
                isAddingNote={isAddingNewNote}
                notes={props.notes}
                errorStatus={props.notesErrorStatus}
                modalSize={props.modalSize}
                onAdd={annotation => {
                    setIsAddingNewNote(true);
                    props.onAddNote(annotation);
                    setIsAddingNewNote(false);
                }}
                onEdit={props.onEditNote}
                onCloseModal={() => setIsModalVisibility(false)}
                disabled={!props.isAddingNotesEnabled}
            />
        </>
    );
}
